const topHeaderTemplate = `
<nav class="main-nav utility-nav navbar-default pull-right">
  <div aria-hidden="false" class="main-nav-menu" id="utility-nav">
    <a class="navbar-toggle utility-nav-toggle" data-toggle-content="#utility-nav" ng-click="mainNavToggle()">
      <i class="fa fa-times"></i>
    </a>
    <ul class="nav navbar-nav">
        <li class="utility-nav-item">
            <header-plan-messaging slides="planMessagingSlides" watch-depth="reference" prevent="prevent" on-view-all-prevent="onViewAllPrevent"></header-plan-messaging>
        </li>
        <li>
            <a
              class="utility-nav-item-link"
              title="{{userProfile.data.firstName}} {{userProfile.data.lastName}}"
              ng-href="{{loginAppURL}}/#/profile?accu={{accu}}"
                  id="topHeaderUserProfileName"
              ng-click="profileClick($event);"
            >
              <img class="user-circle" alt="User Profile" ng-src="{{styleEnv}}customizations/Default/images/user-circle.svg"></img>
              <span>{{userProfile.data.firstName}}&nbsp;{{userProfile.data.lastName}}</span>
              <i class="fa fa-solid fa-chevron-down"></i>
            </a>
        </li>
        <li class="utility-nav-item">
            <a href="" id=“ppt-logout” class="utility-nav-item-link" ng-click="logout($event);" title="Log out" translate="header.Logout">
        </a>
      </li>
    </ul>
  </div>
  <div ng-if="showChangeLanguageButton" uib-dropdown class="hidden-xs nav navbar-nav pull-right">
        <a href="" id="language-dropdown" class="utility-nav-item-link" uib-dropdown-toggle
      translate="header.changeLanguage">
    </a>
    <ul class="uib-dropdown-menu" role="menu" aria-labelledby="language-dropdown">
      <li ng-repeat="locale in availableLocales">
                <a class="locale utility-nav-item-link" href="" ng-click="setLocale(locale.code)">
            {{ locale.name }}
          </a>
      </li>
    </ul>
  </div>
</nav>
`;
export default topHeaderTemplate;